export default __webpack_public_path__ + "ee32475f6d1672eaa4b9c2c0b6397c08.png";